import { CONTACT_EMAIL, SITE_URL } from '../data/products';

const address = {
  '@type': 'PostalAddress',
  streetAddress: '333 Wilson Ave',
  addressLocality: 'Toronto',
  addressRegion: 'ON',
  addressCountry: 'CA',
};

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Simpian Consulting',
  alternateName: 'Simpian',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  email: CONTACT_EMAIL,
  description:
    'Simpian Consulting helps businesses automate processes and become more efficient—manufacturing, distribution, and operational systems with practical AI.',
  address,
  areaServed: [
    { '@type': 'City', name: 'Toronto' },
    { '@type': 'AdministrativeArea', name: 'Ontario' },
    { '@type': 'Country', name: 'Canada' },
    { '@type': 'Country', name: 'Hong Kong' },
  ],
};

export const professionalServiceSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Simpian Consulting',
  url: SITE_URL,
  image: `${SITE_URL}/logo.png`,
  email: CONTACT_EMAIL,
  priceRange: '$$',
  address,
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 43.6532,
    longitude: -79.3832,
  },
  areaServed: ['Toronto', 'Ontario', 'Canada', 'Hong Kong'],
  serviceType: [
    'Process automation consulting',
    'Operational efficiency consulting',
    'Manufacturing systems implementation',
    'Distribution and order-to-delivery automation',
    'AI for business operations',
  ],
};

export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What does Simpian Consulting do?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We help businesses automate processes and become more efficient. We diagnose how work actually happens, design the target flow, build or integrate systems, train operators, and measure outcomes—especially for manufacturers, distributors, and field operators.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are you a SaaS product company or a consulting firm?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We are a consulting firm. We build and implement automation that fits an operation. Interactive scenes on the site illustrate client work, not a self-serve product pitch.',
      },
    },
    {
      '@type': 'Question',
      name: 'Where does Simpian Consulting work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Simpian Consulting is based at 333 Wilson Ave, Toronto, Ontario, Canada, and supports engagements across Canada and Hong Kong in English and Chinese.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do we start a conversation?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Email info@simpian.com or use the contact form to schedule a discovery conversation about the current process.',
      },
    },
  ],
};

export function webPageSchema(name: string, description: string, path: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url: `${SITE_URL}${path}`,
    isPartOf: {
      '@type': 'WebSite',
      name: 'Simpian Consulting',
      url: SITE_URL,
    },
    about: {
      '@type': 'ProfessionalService',
      name: 'Simpian Consulting',
      email: CONTACT_EMAIL,
      address,
    },
  };
}
